import { render, staticRenderFns } from "./UserBalanceAddressesFilters.vue?vue&type=template&id=0c0c4b0a&"
import script from "./UserBalanceAddressesFilters.vue?vue&type=script&lang=js&"
export * from "./UserBalanceAddressesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports